"use client";

import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useTabHandler } from "@/hooks/use-tab-handler";
import { LucideIcon } from "lucide-react";
import { useSyncExternalStore } from "react";

function subscribeToNothing() {
  return () => {};
}

function useIsClient() {
  return useSyncExternalStore(
    subscribeToNothing,
    () => true,
    () => false,
  );
}

function TabsCard({
  tabs,
}: {
  tabs: {
    name: string;
    value: string;
    icon?: LucideIcon;
    content: React.ReactNode;
  }[];
}) {
  const { selectedTab, handleTabChange } = useTabHandler({ options: tabs });
  const isClient = useIsClient();

  if (!isClient) {
    return <div className="w-full" />;
  }

  return (
    <div className="w-full">
      <Tabs
        className="gap-4"
        defaultValue={selectedTab}
        onValueChange={handleTabChange}
      >
        <TabsList className="bg-card flex h-auto w-full flex-wrap gap-2">
          {tabs.map((tab) => (
            <TabsTrigger
              key={tab.value}
              value={tab.value}
              className="flex items-center gap-1 px-2.5 sm:px-3"
            >
              {tab.icon && <tab.icon />}
              {tab.name}
            </TabsTrigger>
          ))}
        </TabsList>

        {tabs.map((tab) => (
          <TabsContent key={tab.value} value={tab.value} className="pt-4">
            {tab.content}
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}

export { TabsCard };
